module.exports = __webpack_public_path__ + "assets/img/btn_draw_once.e23aee64.png";